import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { useParams } from '@thd-olt-component-react/router';
import {
  extend,
  QueryContext
} from '@thd-nucleus/data-sources';
import { LayoutGroup, LayoutManager } from '@thd-olt-component-react/layout-manager';
import { StateDirectory, StateServices } from '@thd-olt-component-react/store-directory';
import { Metadata, StateDirectoryMetadata } from '@thd-olt-component-react/metadata';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { StoreFinderBreadcrumbs } from '../../shared-components/StoreFinderBreadcrumbs';

export const StateDirectoryService = () => {
  declareContexts([QueryContext, ExperienceContext]);
  const { state } = useParams();

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-finder.state-directory-page-load', { state });
  }, [state]);

  return (
    <>
      <LayoutManager name="state-directory-wrapper" useContextForProps>
        <LayoutGroup name="state-directory-metadata">
          <Metadata>
            <StateDirectoryMetadata state={state} />
          </Metadata>
        </LayoutGroup>
        <div className="zone-card">
          <Row className="isBound">
            <LayoutGroup name="state-directory-breadcrumbs" tag={Row}>
              <Row>
                <Col xs={12}>
                  <StoreFinderBreadcrumbs pageName={state} />
                </Col>
              </Row>
            </LayoutGroup>
            <LayoutGroup name="state-directory-content" tag={Row}>
              <Row>
                <Col xs={12}>
                  <StateDirectory state={state} />
                </Col>
                <Col xs={12}>
                  <StateServices state={state} />
                </Col>
              </Row>
            </LayoutGroup>
          </Row>
        </div>
      </LayoutManager>
    </>
  );
};

StateDirectoryService.displayName = 'StateDirectory';
StateDirectoryService.propTypes = {
};

StateDirectoryService.dataModel = extend({},
  StateDirectory,
  StateServices,
  StoreFinderBreadcrumbs,
  StateDirectoryMetadata
);
